import { render, staticRenderFns } from "./PasswordResetSuccessful.vue?vue&type=template&id=046164d6&scoped=true&"
import script from "./PasswordResetSuccessful.vue?vue&type=script&lang=js&"
export * from "./PasswordResetSuccessful.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "046164d6",
  null
  
)

export default component.exports